import { Skill } from '../types';

export const skills: Skill[] = [
  // Linguaggi & Framework
  {
    id: 'csharp',
    name: 'C#',
    level: 5,
    category: 'languages',
  },
  {
    id: 'python',
    name: 'Python',
    level: 4,
    category: 'languages',
  },
  {
    id: 'go',
    name: 'Go',
    level: 3,
    category: 'languages',
  },
    {
    id: 'vbnet',
    name: 'VB.NET',
    level: 5,
    category: 'languages',
  },
  {
    id: 'php',
    name: 'PHP',
    level: 4,
    category: 'languages',
  },
  {
    id: 'javascript',
    name: 'JavaScript',
    level: 4,
    category: 'languages',
  },
  {
    id: 'typescript',
    name: 'TypeScript',
    level: 4,
    category: 'languages',
  },
  {
    id: 'react',
    name: 'React',
    level: 4,
    category: 'languages',
  },
  {
    id: 'nodejs',
    name: 'Node.js',
    level: 4,
    category: 'languages',
  },
  {
    id: 'css',
    name: 'CSS3',
    level: 3,
    category: 'languages',
  },

  // Database
  {
    id: 'mysql',
    name: 'MySQL',
    level: 5,
    category: 'databases',
  },
  {
    id: 'oracle',
    name: 'Oracle',
    level: 3,
    category: 'databases',
  },
  {
    id: 'sqlserver',
    name: 'SQL Server',
    level: 4,
    category: 'databases',
  },
  {
    id: 'access',
    name: 'Microsoft Access',
    level: 5,
    category: 'databases',
  },

  // Sistemi
  {
    id: 'windows',
    name: 'Windows Server',
    level: 5,
    category: 'systems',
  },
  {
    id: 'linux',
    name: 'Linux',
    level: 4,
    category: 'systems',
  },
  {
    id: 'vmware',
    name: 'VMware',
    level: 4,
    category: 'systems',
  },
  {
    id: 'hyperv',
    name: 'Hyper-V',
    level: 4,
    category: 'systems',
  },

  // Network & Infrastructure
  {
    id: 'tcpip',
    name: 'TCP/IP',
    level: 5,
    category: 'network',
  },
  {
    id: 'firewall',
    name: 'Firewall',
    level: 4,
    category: 'network',
  },
  {
    id: 'dns',
    name: 'DNS',
    level: 4,
    category: 'network',
  },
  {
    id: 'dhcp',
    name: 'DHCP',
    level: 4,
    category: 'network',
  },
  {
    id: 'fortigate',
    name: 'Fortigate',
    level: 3,
    category: 'network',
  },
  {
    id: 'structuredcabling',
    name: 'Cablaggio Strutturato',
    level: 5,
    category: 'network',
  },
  {
    id: 'fiberoptic',
    name: 'Fibra Ottica',
    level: 4,
    category: 'network',
  },
  {
    id: 'wirelesslongrange',
    name: 'Connessioni Wireless Lunghe Distanze',
    level: 4,
    category: 'network',
  },

  // Integrazione industriale
  {
    id: 'plcsiemens',
    name: 'PLC Siemens',
    level: 4,
    category: 'industrial',
  },
  {
    id: 'rfid',
    name: 'RFID',
    level: 5,
    category: 'industrial',
  },
  {
    id: 'automagazzini',
    name: 'Automazione magazzini',
    level: 5,
    category: 'industrial',
  },
  {
    id: 'arduino',
    name: 'Arduino',
    level: 3,
    category: 'industrial',
  },

  // Web & UI/UX
  {
    id: 'pwa',
    name: 'PWA',
    level: 3,
    category: 'web',
  },
  {
    id: 'dashboard',
    name: 'Dashboard',
    level: 4,
    category: 'web',
  },
  {
    id: 'grafici',
    name: 'Grafici dinamici',
    level: 4,
    category: 'web',
  },

  // Dev Tools
  {
    id: 'git',
    name: 'Git',
    level: 4,
    category: 'tools',
  },
  {
    id: 'visualstudio2019',
    name: 'Visual Studio 2019',
    level: 5,
    category: 'tools',
  },
  {
    id: 'visualstudio2022',
    name: 'Visual Studio 2022',
    level: 5,
    category: 'tools',
  },
  {
    id: 'visualstudio2026',
    name: 'Visual Studio 2026',
    level: 4,
    category: 'tools',
  },
  {
    id: 'claudecode',
    name: 'Claude Code',
    level: 4,
    category: 'tools',
  },
  {
    id: 'llm',
    name: 'LLM Programming',
    level: 4,
    category: 'tools',
  },
  {
    id: 'aitools',
    name: 'AI Tools & Integration',
    level: 4,
    category: 'tools',
  },
  {
    id: 'davinciresolve',
    name: 'DaVinci Resolve',
    level: 3,
    category: 'tools',
  },
  {
    id: 'mcp',
    name: 'MCP (Model Context Protocol)',
    level: 4,
    category: 'tools',
  },
];